export default __webpack_public_path__ + "static/media/weekend2.b3ba883a.png";